import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import "./prelude.css";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import AddOrder from "../Registration/Order/addOrder";
import AltOrder from "../Registration/Order/altOrder";
import DelOrder from "../Registration/Order/delOrder";
import BottomBar from "../../Components/bottomBar/bottomBar";
import { handleColor } from "../../services/Functions";
import ReportOrders from "../Reports/reportOrders";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

const prelude_ordens = () => {
  const [activeTab, setActiveTab] = React.useState("list");
  return (
    <>
      <Top_bar title="Cadastro ordem de produção" />
      <div className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </div>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = { click: false };
  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const items = [
      { id: "lg4", label: "Histórico de Ordens", eventKey: "list" },
      { id: "lg1", label: "Nova ordem", eventKey: "add-order" },
      { id: "lg2", label: "Alterar Ordem", eventKey: "alt-order" },
      { id: "lg3", label: "Deletar Ordem", eventKey: "del-order" },
    ];
    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            this.props.handleClose();
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
                width: "100%",
               
              }}
            >
              {!this.props.isMobile && (
                <Tab.Content style={{ height: "100%" }}>
                  <Tab.Pane
                    style={{
                      justifyContent: "center",
                    }}
                    mountOnEnter
                    unmountOnExit
                    eventKey="list"
                  >
                    {this.handleClick ? <ReportOrders /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                    mountOnEnter
                    unmountOnExit
                    eventKey="add-order"
                  >
                    {this.handleClick ? <AddOrder /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      overflow: "auto",
                      overflowX: "hidden",
                    }}
                    mountOnEnter
                    unmountOnExit
                    eventKey="alt-order"
                  >
                    {this.handleClick ? <AltOrder /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                    mountOnEnter
                    unmountOnExit
                    eventKey="del-order"
                  >
                    {this.handleClick ? <DelOrder /> : null}
                  </Tab.Pane>
                </Tab.Content>
              )}
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_ordens;
